import React from "react"
import { Button, Col, Row } from "reactstrap"
import useNotificationSettings from "./useNotificationSettings"

function Checkbox({ id, checked, label, onChange }) {
  return (
    <div>
      <input
        type="checkbox"
        id={id}
        name={id}
        checked={checked}
        style={{ margin: "0px 10px" }}
        onChange={onChange}
      />
      <label for={id}>{label}</label>
    </div>
  )
}

export default function NotificationSettings({ customer, notify, auth }) {
  const { values, setValue, handleSubmit } = useNotificationSettings({
    customer,
    notify,
    auth,
  })
  return (
    <Row form className="mb-3">
      <Col md="12">
        <Checkbox
          id="all"
          label="All Notifications"
          checked={values.all}
          onChange={(e) => setValue("all", e.target.checked)}
        />
      </Col>
      <Col md="12">
        <Checkbox
          id="order"
          label="Order Notifications"
          checked={values.order}
          onChange={(e) => setValue("order", e.target.checked)}
        />
      </Col>
      <Col md="12">
        <Checkbox
          id="promo"
          label="Promotions and Offers"
          checked={values.promo}
          onChange={(e) => setValue("promo", e.target.checked)}
        />
      </Col>
      <Col md="12">
        <Checkbox
          id="announcement"
          label="Announcement and Updates"
          checked={values.announcement}
          onChange={(e) => setValue("announcement", e.target.checked)}
        />
      </Col>
      <Col col="12" style={{ margin: "20px 0" }}>
        <Button className="float-right" color="primary" onClick={handleSubmit}>
          Update
        </Button>
      </Col>
    </Row>
  )
}
